import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getHomepage as getHomepageCore } from '@/modules/homepage/domain/resources/core/getHomepage';
import { getHomepage as getHomepageCorporate } from '@/modules/homepage/domain/resources/corpo/getHomepage';
import { useProgram } from '@/modules/programs/hooks/useProgram';
import { AccountTypes } from '@/types';
import { Langs } from '@/types/lang';

export const useHomepage = ({
  accountType,
  homepageId,
  categoryUUID,
}: {
  accountType: AccountTypes;
  homepageId?: string;
  categoryUUID?: string;
}) => {
  const queryClient = useQueryClient();
  const queryKeys = [homepageId || '', categoryUUID || ''].filter((queryKey) => !!queryKey);
  const type = categoryUUID ? 'category' : 'homepage';

  const { data, isFetching, error } = useQuery({
    queryKey: [type, accountType, queryKeys.length ? queryKeys?.[0] : Langs.Fr],
    queryFn: () => {
      if (accountType === 'corporate') {
        return getHomepageCorporate(homepageId);
      }

      return getHomepageCore(categoryUUID);
    },
  });

  const { medias, isLoadingProgram } = useProgram(
    data?.blocks[0]?.items?.[0]?.UUID || '',
    accountType === 'corporate'
  );

  useEffect(() => {
    queryClient.setQueryData(['current-medias'], medias || []);
  }, [medias, queryClient, isLoadingProgram]);

  return {
    isLoadingHomepage: isFetching,
    homepage: data,
    hasErrorHomepage: error,
  };
};
